import { Media, MediaBlock } from '@/payload-types';

export const aspectMap: Record<
  Exclude<
    | NonNullable<MediaBlock['medias']>[number]['aspectRatio']
    | 'employee'
    | 'trueSquare',
    null | undefined
  >,
  (keyof NonNullable<Media['sizes']>)[]
> = {
  none: [],
  square: ['squareSmall', 'squareMedium', 'squareLarge', 'landscapeLarge'],
  trueSquare: ['squareSmall', 'squareMedium', 'squareLarge'],
  employee: [
    'standardSmall',
    'squareMedium',
    'standardMedium',
    'standardLarge',
  ],
  portrait: ['portraitSmall', 'portraitMedium', 'portraitLarge'],
  standard: ['standardSmall', 'standardMedium', 'standardLarge'],
  landscape: [
    'standardSmall',
    'landscapeMedium',
    'landscapeLarge',
    'landscapeFull',
  ],
  cinematic: [
    'standardSmall',
    'landscapeMedium',
    'landscapeLarge',
    'cinematicFull',
  ],
};

export function generateSrcSet(
  sizes?: Media['sizes'] | null,
  aspect?:
    | NonNullable<MediaBlock['medias']>[number]['aspectRatio']
    | 'employee'
    | 'trueSquare'
): string {
  if (!sizes) return '';

  const validAspect = aspect ?? 'none';

  return (aspectMap[validAspect] || [])
    .map((key) => {
      const data = sizes[key];
      return data?.url && data?.width
        ? `${encodeURI(data.url)} ${data.width}w`
        : null;
    })
    .filter(Boolean)
    .join(', ');
}
